import { Component, inject } from "@angular/core";
import { CoreIconButton, CoreSvsLogo, SvsModalService } from "@svs/angular";
import { SettingsModalComponent } from "../../@shared/settings-modal/settings-modal.component";

@Component({
  selector: "app-header-bar",
  imports: [
    CoreIconButton,
    CoreSvsLogo,
  ],
  templateUrl: "./header-bar.component.html",
  styleUrl: "./header-bar.component.scss",
})
export class HeaderBarComponent {
  readonly modal = inject(SvsModalService);

  openSettings() {
    this.modal.open(SettingsModalComponent);
  }

}
